import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AnexoTO } from "src/app/data/schema/Courses/AnexoTO";

@Component({
    selector: "app-attachments-viewer",
    templateUrl: "./attachments-viewer.component.html",
    styleUrls: ["./attachments-viewer.component.scss"]
})
export class AttachmentsViewerComponent implements OnInit {
    private _attachments: AnexoTO[];
    hasContentToShow = false;

    @Input("attachments")
    get attachments(): AnexoTO[] {
        return this._attachments;
    }
    set attachments(anexos: AnexoTO[]) {
        this._attachments = anexos;

        if (
            anexos?.find(
                (x) =>
                    this.getFileType(x.nome) == "image" ||
                    this.getFileType(x.nome) == "audio" ||
                    this.getFileType(x.nome) == "video"
            )
        )
            this.hasContentToShow = true;
    }

    @Output("video-complete")
    private emitVideoComplete = new EventEmitter<boolean>();

    showContent = false;

    constructor() {}

    ngOnInit() {}

    public VideoConvertComplete() {
        this.emitVideoComplete.emit(true);
    }

    getFileType(file: string): string {
        var extension = file.split(".").pop();

        switch (extension?.toLowerCase()) {
            case "jpg":
            case "gif":
            case "jpeg":
            case "png":
            case "bmp":
                return "image";
            case "mp3":
            case "wav":
                return "audio";
            case "mp4":
            case "mkv":
            case "avi":
            case "webm":
                return "video";
        }
    }
}
